export const addNbhp = (str = '') => str.split('-').join('\u2011');
